import React from 'react'
import business1 from "@/assets/img/home-page/business1.png";
import business2 from "@/assets/img/home-page/business2.png";
import business3 from "@/assets/img/home-page/business3.png";
import business4 from "@/assets/img/home-page/business4.png";
import business5 from "@/assets/img/home-page/business5.png";
import business6 from "@/assets/img/home-page/business6.png";
import QueueAnim from "rc-queue-anim";
import { OverPack } from "rc-scroll-anim";
import "./index.less";
const MainBusiness = (props) => {
  const mainBusinessData = [
    { icon: business1, title: '信用评级', content: '基于多方数据分析，科学定位企业风险级别，以信用等级展现企业经营情况，匹配不同的服务机构的准入标准' },
    { icon: business2, title: '信用报告', content: '应用于贷前审批、信用交易、市场准入、贷后预警等场景，快速获取并分析目标主体的多维精确信息，及时防范信贷风险' },
    { icon: business3, title: '风险监控', content: '通过对传统仓储物流基础设施进行数字化和物联网升级，完成"账""货"一致性验证，降低传统动产监管模式下存在的风险，增加小微企业的金融服务获得感' },
    { icon: business4, title: '现金流分析', content: '核实企业真实经营性现金流数据，深度挖掘流水关联交易、隐性负债风险,为信贷业务提供决策依据' },
    { icon: business5, title: '信用管理咨询', content: '提供信用风险诊断、信用风险评估等咨询服务，全面助力中小微企业获得融资便利' },
    { icon: business6, title: '助力数字化转型', content: '以融仓、小工具、基建贷等产品，为金融机构提供引流和风险管理服务，助力金融机构数字化转型升级' },
  ]
  return (
		<OverPack style={{ minHeight: 90 }} always={true} playScale={[0.2, 0.8]}>
			<QueueAnim
				key="queue10"
				interval={120}
				leaveReverse
				type="bottom"
				component={"div"}
			>
				<div className="main-business-warp top-move">
					{
						mainBusinessData.map((item, index) => (
							<div key={`business-${index+1}`} className="business-li">
								<img src={item.icon} alt="" className="business-icon" />
								<div className="business-title">{item.title}</div>
								<div className="business-content">{item.content}</div>
							</div>
						))
					}
          </div>
			</QueueAnim>
		</OverPack>
  )
}

export default MainBusiness;
